import { DEMO_ADVERTISER_ID } from "../config";
import {
  currentMonthFirst,
  isoDate,
  isoTimestamp,
  previousMonthFirst,
  daysAgo,
} from "./dates";

const AUDIO_CATALOG = [
  { display_name: "FM/AM Broadcast", id: "477", type: "inventory_type", value: "2", clusivity: "include" },
  { display_name: "Music Streaming Service", id: "476", type: "inventory_type", value: "1", clusivity: "include" },
  { display_name: "Podcasts", id: "528", type: "inventory_type", value: "3", clusivity: "include" },
  { display_name: "Text To Speech Articles", id: "479", type: "inventory_type", value: "7", clusivity: "include" },
];

const GEO_CATALOG = [
  { id: "US", key: "US", name: "United States", display_name: "United States", type: "country", clusivity: "include" },
  { id: "NY", key: "NY", name: "New York", display_name: "New York", type: "state", clusivity: "include" },
  { id: "CA", key: "CA", name: "California", display_name: "California", type: "state", clusivity: "include" },
  { id: "TX", key: "TX", name: "Texas", display_name: "Texas", type: "state", clusivity: "include" },
];

function buildSeed() {
  const baseAt = isoTimestamp(daysAgo(2));
  return [
    {
      id: 1001,
      advertiser_id: DEMO_ADVERTISER_ID,
      month_year: isoDate(currentMonthFirst()),
      spend_cap: 250000,
      cpa_types: ["Purchase", "App Install"],
      fixed_cpa: 252.0,
      geo: GEO_CATALOG,
      audio_types: AUDIO_CATALOG,
      pricing_mode: "fixed",
      cpa_rates: {},
      status: "approved",
      review_notes: null,
      created_at: baseAt,
      updated_at: baseAt,
    },
    {
      id: 1002,
      advertiser_id: DEMO_ADVERTISER_ID,
      month_year: isoDate(previousMonthFirst()),
      spend_cap: 220000,
      cpa_types: ["Purchase", "App Install"],
      fixed_cpa: 252.0,
      geo: GEO_CATALOG,
      audio_types: AUDIO_CATALOG,
      pricing_mode: "fixed",
      cpa_rates: {},
      status: "approved",
      review_notes: null,
      created_at: isoTimestamp(daysAgo(35)),
      updated_at: isoTimestamp(daysAgo(35)),
    },
  ];
}

let rows = null;
let cachedDate = null;

function init() {
  const today = new Date().toISOString().slice(0, 10);
  if (rows && cachedDate === today) return;
  cachedDate = today;
  rows = buildSeed();
}

export function getCampaignSettings() {
  init();
  return rows;
}

export function insertCampaignSetting(body) {
  init();
  const newRow = {
    id: Date.now(),
    pricing_mode: "fixed",
    cpa_rates: {},
    status: "pending",
    review_notes: null,
    created_at: new Date().toISOString(),
    updated_at: new Date().toISOString(),
    ...body,
  };
  rows = [newRow, ...rows];
  return newRow;
}

export function updateCampaignSetting(patch, filterFn) {
  init();
  rows = rows.map((r) =>
    filterFn(r) ? { ...r, ...patch, updated_at: new Date().toISOString() } : r,
  );
}

